import { z } from "zod";

export const CallbackDetailsModelSchema = z.object({
  email: z.string().nullable(),
  contactNumber: z.string().nullable(),
  fullName: z.string().nullable(),
});
